import {OrganismeModel} from "./organisme.model";
import {GroupeFormComponent} from "../common-parts/forms/groupe-form/groupe-form.component";
import {SelectComptePartageComponent} from "../common-parts/selects/select-compte-partage/select-compte-partage.component";
import { UserModel } from "./user.model";

export class ProcurationModel {
  public id: number;
  public mandant: UserModel;
  public mandataire: UserModel;
  public createdAt: Date;
  public updatedAt: Date;

  constructor(maxDepth = 1) {
    maxDepth--;
    this.id = 0;
    this.mandant = new UserModel();
    this.mandataire = new UserModel();
    this.createdAt = new Date;
    this.updatedAt = new Date;
  }

  getDefaultTitle() {
    return 'Procuration';
  }

  getDefaultPrefixTitle() {
    return 'une';
  }

  getIndex() {
    return 'id';
  }

  getDefaultLibelleFields() {
    return ['mandant'];
  }

  getDefaultSelectComponent() {
    return SelectComptePartageComponent;
  }

  getDefaultFormComponent() {
    return null;
  }

  getEntityUrl() {
    return 'procuration';
  }
}
